// test268
(268 && 0);
